import axios from "axios";
import { setHeaders } from "./axiosInterceptors";

// Axios instance
const axiosInstanceMicrosite = axios.create({
  // TODO: I would prefer to have /api/v1 in the URL so we can actively support multiple API versions
  baseURL: "/microsite/api",
  headers: {
    Accept: "application/json,text/plain",
  },
});

setHeaders(axiosInstanceMicrosite);

export default axiosInstanceMicrosite;
